import * as constants from '../constants/calculatorConstants'
import { Profile } from './calculationUtils';


export function formatBytes(bytes: number, decimals = 1) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function formatCpu(cpu: number, decimals = 1) {
    if (cpu === 0) return '0 vCPU';
    const dm = decimals < 0 ? 0 : decimals;
    return parseFloat((cpu / 1000.0).toFixed(dm)) + " vCPU";
}

export function getMultizonalFactor(nodes: number) {
    console.log(nodes)
    let factor = 1.5;
    if (nodes % 3 === 1) {
        factor = nodes/(2*(Math.floor(nodes/3)));
    }
    else if (nodes % 3 === 2) {
        factor = 1.5 + 1/(2*(Math.ceil(nodes/3)-1));
    }
    console.log(factor)

    return factor;
}

const additionalRequirements = (dimensionName: string, dimensionValue: number, cpu: number, ram: number): string => {
    console.log("Name: ", dimensionName, ", Value: ", dimensionValue, cpu, ram)
    if (dimensionValue === 0) {
        return "";
    }
    if (cpu === 0 && ram === 0) {
        return `* Handling **${dimensionValue}** of **${dimensionName}** can be handled by the base replicas.`;
    }
    return `* Handling **${dimensionValue}** of **${dimensionName}** requires an additional **${formatCpu(cpu, 1)}** / **${formatBytes(ram * 1024 * 1024, 1)}**.`;
};


function throwUnsupportedCoresError(): never {
    throw new Error("Cores on host value is not supported.");
}

export function calculateAllocatableCPU(coresOnHost: number): number {
    return coresOnHost < 1 ? coresOnHost - 60 / 1000 :
        coresOnHost <= 2 ? coresOnHost - 100 / 1000 :
            coresOnHost <= 4 ? coresOnHost - 140 / 1000 :
                coresOnHost <= 8 ? coresOnHost - 180 / 1000 :
                    coresOnHost <= 16 ? coresOnHost - 260 / 1000 :
                        coresOnHost <= 32 ? coresOnHost - 420 / 1000 :
                            coresOnHost <= 64 ? coresOnHost - 740 / 1000 :
                                throwUnsupportedCoresError();
}

export function calculateAllocatableMemory(memoryInBytes: number): number {
    const memoryInGB = memoryInBytes / (1024 * 1024 * 1024);
    const hardEvictionThreshold = 750 / 1024;
    const effectiveMemory = Math.max(memoryInGB - hardEvictionThreshold, 0);

    const reservedMemory = (
        (effectiveMemory <= 4 ? effectiveMemory * 0.25 :
            effectiveMemory <= 8 ? 4 * 0.25 + (effectiveMemory - 4) * 0.20 :
                effectiveMemory <= 16 ? 4 * 0.25 + 4 * 0.20 + (effectiveMemory - 8) * 0.10 :
                    effectiveMemory <= 128 ? 4 * 0.25 + 4 * 0.20 + 8 * 0.10 + (effectiveMemory - 16) * 0.06 :
                        4 * 0.25 + 4 * 0.20 + 8 * 0.10 + 112 * 0.06 + (effectiveMemory - 128) * 0.02) + hardEvictionThreshold
    );

    const allocatableMemoryInGB = memoryInGB - reservedMemory;
    return allocatableMemoryInGB * (1024 * 1024 * 1024);
}

export function processOrchestratorProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number,) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let concurrentRobots = +product.properties["concurrentRobots"];
    if (concurrentRobots <= 100) {
        // no-op
    } else if (concurrentRobots <= 1000) {
        cpuDelta += 4000;
        ramDelta += 8000;
    } else if (concurrentRobots <= 10000) {
        cpuDelta += 15000;
        ramDelta += 16000;
    } else {
        cpuDelta += 75000;
        ramDelta += 22000;
    }

    details.push(additionalRequirements("Robots", concurrentRobots, cpuDelta, ramDelta));
    totalCpu += cpuDelta;
    totalRam += ramDelta;

    return {totalCpu, totalRam, details, totalPvc: 0};
}

export function processPlatformProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number,) {
    if (product.properties === undefined) {
        return ;
    }

    {
        let cpuDelta = 0;
        let ramDelta = 0;
        let loginPerSecond = +product.properties["loginPerSecond"];
        if (loginPerSecond <= 5) {
            // no-op
        } else if (loginPerSecond <= 20) {
            cpuDelta = 1000;
            ramDelta = 1000;
        } else if (loginPerSecond <= 50) {
            cpuDelta = 3000;
            ramDelta = 12000;
        } else if (loginPerSecond <= 100) {
            cpuDelta = 9000;
            ramDelta = 20000;
        } else {
            cpuDelta = 16000;
            ramDelta = 30000;
        }
        details.push(additionalRequirements("Logins Per Second", loginPerSecond, cpuDelta, ramDelta));
        totalCpu += cpuDelta;
        totalRam += ramDelta;
    }

    {
        let cpuDelta = 0;
        let ramDelta = 0;
        let concurrentUsers = +product.properties["concurrentUsers"];
        if (concurrentUsers <= 10) {
            // no-op
        } else if (concurrentUsers <= 25) {
            cpuDelta = 1000;
            ramDelta = 1500;
        } else if (concurrentUsers <= 50) {
            cpuDelta = 3000;
            ramDelta = 4500;
        } else if (concurrentUsers <= 100) {
            cpuDelta = 5000;
            ramDelta = 6500;
        } else if (concurrentUsers <= 150) {
            cpuDelta = 7000;
            ramDelta = 8500;
        } else {
            cpuDelta = 10000;
            ramDelta = 12000;
        }
        details.push(additionalRequirements("Concurrent Users", concurrentUsers, cpuDelta, ramDelta));
        totalCpu += cpuDelta;
        totalRam += ramDelta;
    }

    return { totalCpu, totalRam, details, totalPvc: 0 };
}

export function processAutomationOpsProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number,) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let concurrentUsers = +product.properties["concurrentUsers"];
    if (concurrentUsers <= 10) {
        // no-op
    } else if (concurrentUsers <= 55) {
        cpuDelta = 1500;
        ramDelta = 1500;
    } else {
        cpuDelta = 4000;
        ramDelta = 2000;
    }
    details.push(additionalRequirements("Concurrent Users", concurrentUsers, cpuDelta, ramDelta));
    totalCpu += cpuDelta;
    totalRam += ramDelta;

    return { totalCpu, totalRam, details, totalPvc: 0 };
}

export function processAutomationHubProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number,) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let concurrentUsers = +product.properties["concurrentUsers"];
    if (concurrentUsers <= 10) {
        // no-op
    } else if (concurrentUsers <= 20) {
        cpuDelta = 1000;
        ramDelta = 2000;
    } else {
        cpuDelta = 7000;
        ramDelta = 4000;
    }
    details.push(additionalRequirements("Concurrent Users", concurrentUsers, cpuDelta, ramDelta));
    totalCpu += cpuDelta;
    totalRam += ramDelta;

    return { totalCpu, totalRam, details, totalPvc: 0 };
}

export function computeDocumentUnderstandingOnDemandResourceRequirements(product: ProductOptionInterface, profile: Profile) {
    if (product.properties === undefined || !!!product.properties["isModernProjectsEnabled"]) {
        return ;
    }

    let cpu = 0;
    let ram = 0;
    if (profile === Profile.EvaluationOnly || profile == Profile.Lite){
        cpu = 6.21 * 1000;
        ram = 8.88 * 1024;
    } else {
        cpu = 11.7 * 1000;
        ram = 16.7 * 1024;
    }

    return { cpu, ram}
}

const calculateDUModelRequirements = (modelVersion: string, pagesPerHour: number, processingTimeSeconds: number = 12) => {
    let cpuDelta, ramDelta;
    switch (modelVersion) {
      case "23.4":
        if (pagesPerHour <= 110) {
          cpuDelta = 1000;
        } else if (pagesPerHour <= 170) {
          cpuDelta = 2000;
        } else if (pagesPerHour <= 250) {
          cpuDelta = 4000;
        } else {
          cpuDelta = 6 * 1000;
        }
        ramDelta = 4 * 1024 * cpuDelta/1000;
        break;
      case "23.7":
      case "23.10":
        if (pagesPerHour <= 180) {
          cpuDelta = 1000;
        } else if (pagesPerHour <= 240) {
          cpuDelta = 2000;
        } else if (pagesPerHour <= 325) {
          cpuDelta = 4000;
        } else {
          cpuDelta = 6 * 1000;
        }
        ramDelta = 4 * 1024 * cpuDelta/1000;
        break;
      default:
        cpuDelta = 1000 * Math.ceil(processingTimeSeconds * pagesPerHour / 3600);
        ramDelta = 4 * 1024 * Math.ceil(processingTimeSeconds * pagesPerHour / 3600);
        break;
    }
    return { cpuDelta, ramDelta };
  };

export function processDocumentUnderstandingProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number) {
    if (product.properties === undefined) {
        return ;
    }

    let modelVersion = product.properties["modelVersion"];

    {
        let generalExtractorPerHour = +product.properties["generalExtractorPerHour"];
        if (generalExtractorPerHour > 0) {
            const { cpuDelta, ramDelta } = calculateDUModelRequirements(modelVersion, generalExtractorPerHour);
            details.push(additionalRequirements("General Extractor (pages per hour)", generalExtractorPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let invoicesPerHour = +product.properties["invoicesPerHour"];
        if (invoicesPerHour > 0) {
            const { cpuDelta, ramDelta } = calculateDUModelRequirements("", invoicesPerHour, 5);
            details.push(additionalRequirements("Invoices (pages per hour)", invoicesPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let receiptsPerHour = +product.properties["receiptsPerHour"];
        if (receiptsPerHour > 0) {
            const { cpuDelta, ramDelta } = calculateDUModelRequirements(modelVersion, receiptsPerHour);
            details.push(additionalRequirements("Receipts (pages per hour)", receiptsPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let purchaseOrdersPerHour = +product.properties["purchaseOrdersPerHour"];
        if (purchaseOrdersPerHour > 0) {
            const { cpuDelta, ramDelta } = calculateDUModelRequirements(modelVersion, purchaseOrdersPerHour);
            details.push(additionalRequirements("Purchase Order (pages per hour)", purchaseOrdersPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let utilityBillsPerHour = +product.properties["utilityBillsPerHour"];
        if (utilityBillsPerHour > 0) {
            const { cpuDelta, ramDelta } = calculateDUModelRequirements(modelVersion, utilityBillsPerHour);
            details.push(additionalRequirements("Utility Bills (pages per hour)", utilityBillsPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let ocrPerHour = +product.properties["ocrPerHour"];
        if (ocrPerHour > 0) {
            let cpuDelta = 4000 * Math.ceil(2 * ocrPerHour / 3600);
            let ramDelta = 8 * 1024 * Math.ceil(2 * ocrPerHour / 3600);
            details.push(additionalRequirements("OCR (pages per hour)", ocrPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let shredsPerHour = +product.properties["shredsPerHour"];
        if (shredsPerHour > 0) {
            let cpuDelta = 1000 * Math.ceil(shredsPerHour / 1500.0);
            console.log(cpuDelta, shredsPerHour)
            let ramDelta = shredsPerHour > 0 ? 6 * 1024 : 0;
            details.push(additionalRequirements("Intelligent Form Extractor (handwriting shreds per hour)", shredsPerHour, cpuDelta, ramDelta));
            totalCpu += cpuDelta;
            totalRam += ramDelta;
        }
    }

    {
        let isModernExperienceEnabled = !!product.properties["isModernProjectsEnabled"];
        if (isModernExperienceEnabled) {
            let cpuDelta = 0;
            let ramDelta = 0;
            let customModelPagesPerHour = getNumericValue(product.properties["customModelPagesPerHour"]);
            let oobModelPagesPerHour = getNumericValue(product.properties["oobModelPagesPerHour"]);
            let modelsTrainingInParallel = getNumericValue(product.properties["modelsTrainingInParallel"]);
            // training cpu + training classifier
            let trainingReplicas = Math.max(1, modelsTrainingInParallel)
            cpuDelta += Math.ceil(trainingReplicas * 1.6) * 1000;
            ramDelta += trainingReplicas * 8.38 * 1024;
            // digitizer cpu pages
            let digitizerReplicas = Math.ceil((customModelPagesPerHour + oobModelPagesPerHour) / 556)
            cpuDelta += digitizerReplicas * 2 * 1000;
            ramDelta += digitizerReplicas * 3.3 * 1024;
            // framework cpu
            let frameworkReplicas = Math.ceil((customModelPagesPerHour + oobModelPagesPerHour) / 215)
            cpuDelta += frameworkReplicas * 1000;
            ramDelta += frameworkReplicas * 1.2 * 1024;
            // classifier cpu
            let classifierReplicas = Math.ceil((Math.max(1, oobModelPagesPerHour)) / 1200)
            cpuDelta += classifierReplicas * 1000;
            ramDelta += classifierReplicas * 2.384 * 1024;
            // custom classfier cpu
            let customClassifierReplicas = Math.ceil((Math.max(1, customModelPagesPerHour)) / 15000)
            cpuDelta += customClassifierReplicas * 1.05 * 1000;
            ramDelta += customClassifierReplicas * 3.128 * 1024;
            details.push(`* Handling **Custom Model Pages (per hour)** of **${customModelPagesPerHour}** and **OOB Model Pages (per hour)** of **${oobModelPagesPerHour}** requires an additional **${formatCpu(cpuDelta, 1)}** / **${formatBytes(ramDelta * 1024 * 1024, 1)}**.`);
            totalCpu += cpuDelta;
        }
    }
    return { totalCpu, totalRam, details, totalPvc: 0 };
}

export function processActionCenterProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let concurrentUsers = +product.properties["concurrentUsers"];

    if (concurrentUsers <= 50) {
        // no-op
    } else if (concurrentUsers <= 100) {
        cpuDelta = 200;
        ramDelta = 500;
    } else if (concurrentUsers <= 500) {
        cpuDelta = 600;
        ramDelta = 1500;
    } else {
        cpuDelta = 1200;
        ramDelta = 3000;
    }

    totalCpu += cpuDelta;
    totalRam += ramDelta;

    details.push(additionalRequirements("Concurrent Users", concurrentUsers, cpuDelta, ramDelta));
    return { totalCpu, totalRam, details, totalPvc: 0};
}

export function processTestManagerProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let concurrentUsers = +product.properties["concurrentUsers"];

    if (concurrentUsers <= 100) {
        // no-op
    } else if (concurrentUsers <= 300) {
        cpuDelta = 400;
        ramDelta = 900;
    } else {
        cpuDelta = 800;
        ramDelta = 1800;
    }

    details.push(additionalRequirements("Concurrent Users", concurrentUsers, cpuDelta, ramDelta));
    totalCpu += cpuDelta;
    totalRam += ramDelta;

    return { totalCpu, totalRam, details, totalPvc: 0 };
}

export function processAICenterProduct(product : ProductOptionInterface, details : Array<string>, totalCpu : number, totalRam : number, totalPvc : number) {
    if (product.properties === undefined) {
        return ;
    }

    let cpuDelta = 0;
    let ramDelta = 0;
    let numberOfSkills = +product.properties["numberOfSkills"];

    if (numberOfSkills > 0) {
        cpuDelta = 1000 * numberOfSkills;
        ramDelta = 4 * 1024 * numberOfSkills;
        details.push(additionalRequirements("Skills", numberOfSkills, cpuDelta, ramDelta));
        totalCpu += cpuDelta;
        totalRam += ramDelta;
    }

    let numberOfPipelines = +product.properties["numberOfPipelines"];
    if (numberOfPipelines > 0) {
        cpuDelta = 1000 * numberOfPipelines;
        ramDelta = 12 * 1024 * numberOfPipelines;
        let propName = "Concurrent Pipelines";
        details.push(additionalRequirements(propName, numberOfPipelines, cpuDelta, ramDelta));
        totalCpu += cpuDelta;
        totalRam += ramDelta;
        // AI center requires an additional dedicated disk with 105Gi for each training pipeline
        totalPvc += 105 * numberOfPipelines;
        details.push(`* Handling **${numberOfPipelines}** of **${propName}** requires an additional dedicated **${totalPvc}** GiB PVC. This dedicated disk for AI center should be on the node where the training pipelines are running.`);
    }

    return { totalCpu, totalRam, totalPvc, details };
}


export function calculateAsRobotNode(formData: CalculatorFormDataType, isAutomationSuiteRobotsEnabled: boolean) {
    let asRobotNodeCpu = 0;
    let asRobotNodeRam = 0;
    let asRobotNodeDisk = 10;
    let isAdditionalNodeNeededEval = false;
    if (isAutomationSuiteRobotsEnabled) {
        let asRobotProduct = formData.products.filter(p => p.key == constants.AUTOMATION_SUITE_ROBOTS_PRODUCT_OPTION.key)[0];
        if (asRobotProduct.properties !== undefined) {
            asRobotNodeCpu += asRobotProduct.properties["concurrentSmallRobots"] * 500;
            asRobotNodeCpu += asRobotProduct.properties["concurrentStandardRobots"] * 1000;
            asRobotNodeCpu += asRobotProduct.properties["concurrentMediumRobots"] * 2000;
            asRobotNodeCpu += asRobotProduct.properties["concurrentLargeRobots"] * 6000;
            asRobotNodeRam += asRobotProduct.properties["concurrentSmallRobots"] * 1 * 1024 * 1024 * 1024;
            asRobotNodeRam += asRobotProduct.properties["concurrentStandardRobots"] * 2 * 1024 * 1024 * 1024;
            asRobotNodeRam += asRobotProduct.properties["concurrentMediumRobots"] * 4 * 1024 * 1024 * 1024;
            asRobotNodeRam += asRobotProduct.properties["concurrentLargeRobots"] * 10 * 1024 * 1024 * 1024;
            asRobotNodeDisk += asRobotProduct.properties["concurrentSmallRobots"] * 1;
            asRobotNodeDisk += asRobotProduct.properties["concurrentStandardRobots"] * 2;
            asRobotNodeDisk += asRobotProduct.properties["concurrentMediumRobots"] * 4;
            asRobotNodeDisk += asRobotProduct.properties["concurrentLargeRobots"] * 10;
            isAdditionalNodeNeededEval = (asRobotProduct.properties["concurrentSmallRobots"] > 5 ||
                asRobotProduct.properties["concurrentStandardRobots"] > 0 ||
                asRobotProduct.properties["concurrentMediumRobots"] > 0 ||
                asRobotProduct.properties["concurrentLargeRobots"] > 0 )
        }
    }

    return { asRobotNodeCpu, asRobotNodeRam, asRobotNodeDisk, isAdditionalNodeNeededEval };
}

export function handleDocumentUnderstanding(formData: CalculatorFormDataType): {duGpuCount: number, retrainingRequired: boolean, ocrGpuRequired: boolean, modernExperienceGpuInfo : Map<string, number>} {
    let duGpuCount = 0;
    let duProducts = formData.products.filter(p => p.key == constants.DOCUMENT_UNDERSTANDING_PRODUCT_OPTION.key);
    let retrainingRequired = false;
    let ocrGpuRequired = false;
    let modernExperienceGpuInfo = new Map<string, number>();
    if (duProducts.length > 0) {
        let duProduct = duProducts[0];
        if (duProduct.properties !== undefined) {
            let ocrPerHour = +duProduct.properties["ocrPerHour"];
            if (ocrPerHour > 60) {
                duGpuCount += 1
                ocrGpuRequired = true;
            }
            retrainingRequired = !!duProduct.properties["retrainingRequired"];
            if (retrainingRequired) {
                duGpuCount += 1
            }

            let isModernProjectsEnabled = !!duProduct.properties["isModernProjectsEnabled"];
            if (isModernProjectsEnabled) {
                let customModelPagesPerHour = getNumericValue(duProduct.properties["customModelPagesPerHour"]);
                let oobModelPagesPerHour = getNumericValue(duProduct.properties["oobModelPagesPerHour"]);
                let modelsTrainingInParallel = getNumericValue(duProduct.properties["modelsTrainingInParallel"]);
                modernExperienceGpuInfo.set(constants.OCR_REPLICAS,  Math.max(1, Math.ceil((customModelPagesPerHour + oobModelPagesPerHour) / 679)));
                modernExperienceGpuInfo.set(constants.CUSTOM_MODEL_TRAINING_REPLICAS, Math.max(1, modelsTrainingInParallel));
                modernExperienceGpuInfo.set(constants.CUSTOM_MODEL_REPLICAS, Math.max(1, Math.ceil(customModelPagesPerHour / 1500 + modelsTrainingInParallel)))
                modernExperienceGpuInfo.set(constants.OOB_MODEL_REPLICAS, Math.max(1, Math.ceil(oobModelPagesPerHour / 2571)))
            }
        }
    }
    return {duGpuCount, retrainingRequired, ocrGpuRequired, modernExperienceGpuInfo};
}


function getNumericValue(value: any): number {
    if (value === undefined) {
        return 0;
    }
    return +value;
}